import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ProblemSection() {
  const revealRef = useScrollReveal();
  const problems = [{
    icon: '💬',
    title: 'Afirmaciones positivas',
    text: "Tu boca decía 'soy abundante' mientras tu campo electromagnético gritaba miedo. La frecuencia del miedo gana siempre.",
    borderColor: 'border-t-[#7B5CE8]'
  }, {
    icon: '🧠',
    title: 'Análisis intelectual',
    text: 'Entender POR QUÉ te hirieron no disuelve la carga atómica en tus células. La lógica es 3D. El trauma es no-local.',
    borderColor: 'border-t-[#C9A96E]'
  }, {
    icon: '💪',
    title: 'Fuerza de voluntad',
    text: "Mientras 'intentas' cambiar, le dices al campo que algo está mal. El universo responde a tu estado de ser, no a tu esfuerzo.",
    borderColor: 'border-t-[#FAF7F0]'
  }];
  return <section className="relative bg-brand-cream py-[60px] md:py-[100px] px-[5%] overflow-hidden" data-id="element-157">
      <div ref={revealRef} className="max-w-7xl mx-auto relative z-10 reveal" data-id="element-158">
        <div className="text-center mb-[56px]" data-id="element-159">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-160">
            EL PROBLEMA
          </div>
          <h2 className="font-display italic text-[clamp(36px,5vw,48px)] text-brand-ink leading-tight mb-4" data-id="element-161">
            ¿Por qué lo que intentaste antes no funcionó?
          </h2>
          <p className="font-body text-[16px] text-brand-ink/60 max-w-xl mx-auto" data-id="element-162">
            No fue tu culpa. Fue el nivel desde el que operabas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-163">
          {problems.map((problem, i) => <div key={i} className={`bg-brand-dark border border-brand-dark/10 border-t-[3px] ${problem.borderColor} rounded-[16px] p-[32px] transition-all duration-300 hover:-translate-y-[6px] hover:shadow-[0_20px_40px_rgba(0,0,0,0.1)]`} data-id="element-164">
              <div className="text-[32px] mb-5" data-id="element-165">{problem.icon}</div>
              <h3 className="font-body text-[16px] font-medium text-brand-cream mb-3" data-id="element-166">
                {problem.title}
              </h3>
              <p className="font-body text-[14px] text-brand-cream/60 leading-[1.7]" data-id="element-167">
                {problem.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}